export const menuParticipationItems = [
  {
    name: 'Dashboard',
    icon: 'fas fa-gauge-high nav-icon',
    link: '/app/dashboard',
    class: 'menu-item dashboard',
    menu: 'Vendor Hub',
  },
  {
    name: 'Profile',
    icon: 'fas fa-id-card nav-icon',
    link: '/app/profile',
    class: 'menu-item profile',
    menu: 'Vendor Hub',
  },

  // You can keep them separate for now; later these may live under a parent "Listings"
  {
    name: 'Products',
    icon: 'fas fa-box-open nav-icon',
    link: '/app/products',
    class: 'menu-item',
    menu: 'Listings',
  },
  {
    name: 'Adverts',
    icon: 'fas fa-bullhorn nav-icon',
    link: '/app/adverts',
    class: 'menu-item',
    menu: 'Listings',
  },

  // Optional near-term additions (commented until routes exist)
  // { name: 'Analytics', icon: 'fas fa-chart-line nav-icon', link: '/app/vendor/analytics', class: 'menu-item', menu: 'Insights' },
  // { name: 'Reviews', icon: 'fas fa-star-half-stroke nav-icon', link: '/app/vendor/reviews', class: 'menu-item', menu: 'Insights' },
  // { name: 'Referrals', icon: 'fas fa-right-left nav-icon', link: '/app/vendor/referrals', class: 'menu-item', menu: 'Insights' },
  // { name: 'Payouts', icon: 'fas fa-credit-card nav-icon', link: '/app/vendor/payouts', class: 'menu-item', menu: 'Account' },
  // { name: 'Support', icon: 'fas fa-life-ring nav-icon', link: '/app/vendor/support', class: 'menu-item', menu: 'Account' },
];

export const menuItems = [
  // My Hub (identity + home)
  {
    name: 'Home',
    icon: 'fas fa-gauge-high nav-icon',
    link: '/app/dashboard',
    menu: 'My Hub',
    tourId: 'tour-sidebar-dashboard',
  },
  {
    name: 'Profile',
    icon: 'fas fa-id-card nav-icon',
    link: '/app/profile',
    menu: 'My Hub',
  },

  // Care (dog-centric features)
  {
    name: 'My Dog',
    icon: 'fas fa-dog nav-icon',
    link: '/app/dog',
    menu: 'Care',
  },
  {
    name: 'Memorial',
    icon: 'fas fa-heart nav-icon',
    link: '/app/memorial',
    menu: 'Care',
  },

  // Explore (content + providers + shopping)
  {
    name: 'Library',
    icon: 'fas fa-book-open nav-icon',
    link: '/app/library',
    menu: 'Explore',
  },
  {
    name: 'Directory',
    icon: 'fas fa-address-book nav-icon',
    link: '/app/directory',
    menu: 'Explore',
  },
  {
    name: 'Marketplace',
    icon: 'fas fa-store nav-icon',
    link: '/app/marketplace',
    menu: 'Explore',
  },

  // Planner
  {
    name: 'Calendar',
    icon: 'fas fa-calendar-alt nav-icon',
    link: '/app/calendar',
    menu: 'Planner',
  },

  // Community
  {
    name: 'Members',
    icon: 'fas fa-user-group nav-icon',
    link: '/app/user/users',
    menu: 'Community',
  },
  {
    name: 'Participants',
    icon: 'fas fa-briefcase nav-icon',
    link: '/app/user/participants',
    menu: 'Community',
  },

  // Assist (help, Q&A, messages)
  {
    name: 'Ask SMART',
    icon: 'fas fa-comment-medical nav-icon',
    link: '/app/question',
    menu: 'Assist',
  },
  {
    name: 'Help Center',
    icon: 'fas fa-circle-question nav-icon',
    link: '/app/faq',
    menu: 'Assist',
  },
  {
    name: 'Messages',
    icon: 'fas fa-envelope-open-text nav-icon',
    link: '/app/contact',
    menu: 'Assist',
  },
];
// Conditionally add admin menus
export const adminMenuItems = [
  // People
  {
    name: 'Members',
    icon: 'fas fa-user-shield nav-icon',
    link: '/app/admin/user/users',
    menu: 'Admin',
  },
  {
    name: 'Participants',
    icon: 'fas fa-briefcase nav-icon',
    link: '/app/admin/user/participants',
    menu: 'Admin',
  },

  // Content
  {
    name: 'Library',
    icon: 'fas fa-book nav-icon',
    link: '/app/admin/library',
    menu: 'Admin',
  },
  {
    name: 'Articles',
    icon: 'fas fa-newspaper nav-icon',
    link: '/app/admin/articles',
    notification: 'beta',
    menu: 'Admin',
  },
  {
    name: 'Directory',
    icon: 'fas fa-folder-tree nav-icon',
    link: '/app/admin/directory',
    menu: 'Admin',
  },
  {
    name: 'FAQ',
    icon: 'fas fa-circle-question nav-icon',
    link: '/app/admin/faq',
    menu: 'Admin',
  },

  // Commerce
  {
    name: 'Marketplace',
    icon: 'fas fa-store nav-icon',
    link: '/app/admin/marketplace',
    menu: 'Admin',
  },

  // Verification
  {
    name: 'Verification',
    icon: 'fas fa-store nav-icon',
    link: '/app/admin/verification',
    menu: 'Admin',
  },

  // System
  {
    name: 'System Errors',
    icon: 'fas fa-triangle-exclamation nav-icon',
    link: '/app/admin/errors',
    menu: 'Admin',
  },

  // Analytics
  {
    name: 'Analytics',
    icon: 'fas fa-chart-line nav-icon',
    menu: 'Admin',
    children: [
      {
        name: 'Website',
        icon: 'fas fa-globe nav-icon',
        link: '/app/admin/website/analytics',
      },
      {
        name: 'Portal',
        icon: 'fas fa-columns nav-icon',
        link: '/app/admin/portal/analytics',
      },
    ],
  },

  // Kanban
  {
    name: 'Tasks',
    icon: 'fas fa-triangle-exclamation nav-icon',
    link: '/app/admin/kanban',
    menu: 'Admin',
  },
];
